<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <footer class="bg-white text-slate-800 py-20 px-6 md:px-20">
    <div class="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      <!-- Brand Section -->
      <div class="lg:col-span-1">
        <div class="flex items-center gap-4 mb-8">
          <div class="w-56 h-20 rounded-lg overflow-hidden">
            <img 
              src="/images/bi-logo.jpg" 
              alt="Brand Integrated Logo" 
              class="w-full h-full object-contain"
              style="display: block;"
            />
          </div>
        </div>
        <p class="text-slate-600 text-sm leading-relaxed max-w-xs">
          The premium strategic advisory for brands that refuse to be ignored.
        </p>
      </div>

      <!-- Offices Section -->
      <div>
        <h6 class="font-bold uppercase tracking-widest text-xs text-primary mb-6">Office</h6>
        <p class="text-sm text-slate-600">
          Brand Integrated Consulting LLP<br/>
          Nairobi, Kenya
        </p>
      </div>

      <!-- Contact Section -->
      <div>
        <h6 class="font-bold uppercase tracking-widest text-xs text-primary mb-6">Contact</h6>
        <p class="text-sm text-slate-600 mb-4">
          <a href="mailto:info@brandintegrated.com" class="hover:text-primary transition-colors">
            info@brandintegrated.com
          </a>
        </p>
        <p class="text-sm text-slate-600">Tel: +254 20 4938 268</p>
      </div>

      <!-- Newsletter Section -->
      <div>
        <h6 class="font-bold uppercase tracking-widest text-xs text-primary mb-6">Newsletter</h6>
        <div class="flex border-b border-slate-300 pb-2">
          <input 
            class="bg-transparent border-none focus:ring-0 text-sm w-full placeholder:text-slate-500 text-slate-800" 
            placeholder="Email address" 
            type="email"
          />
          <button type="button" class="inline-flex btn-header-yellow shrink-0" aria-label="Subscribe">
            <span class="material-symbols-outlined text-[22px]">arrow_forward</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Bottom Section -->
    <div class="max-w-[1400px] mx-auto mt-12 md:mt-20 pt-6 md:pt-8 border-t border-slate-300">
      <!-- Mobile: Centered stacked layout -->
      <div class="flex flex-col items-center gap-3 md:hidden">
        <p class="text-xs text-slate-500 text-center">© {{ new Date().getFullYear() }} Brand Integrated Consulting. All rights reserved.</p>
        <div class="flex flex-wrap justify-center gap-4 md:gap-6">
          <a class="text-xs text-slate-500 hover:text-slate-800 transition-colors" href="#">Privacy Policy</a>
          <a class="text-xs text-slate-500 hover:text-slate-800 transition-colors" href="#">Terms of Service</a>
          <a class="text-xs text-slate-500 hover:text-slate-800 transition-colors" href="/admin/login">Admin Login</a>
          <a class="text-xs text-slate-500 hover:text-slate-800 transition-colors" href="https://sitati.vercel.app" target="_blank">Designed and developed by Sitati</a>
        </div>
      </div>
      
      <!-- Desktop: Side-by-side layout -->
      <div class="hidden md:flex justify-between items-center">
        <p class="text-xs text-slate-500">© {{ new Date().getFullYear() }} Brand Integrated Consulting. All rights reserved.</p>
        <div class="flex gap-6">
          <a class="text-xs text-slate-500 hover:text-slate-800 transition-colors" href="#">Privacy Policy</a>
          <a class="text-xs text-slate-500 hover:text-slate-800 transition-colors" href="#">Terms of Service</a>
          <a class="text-xs text-slate-500 hover:text-slate-800 transition-colors" href="/admin/login">Admin Login</a>
          <a class="text-xs text-slate-500 hover:text-slate-800 transition-colors" href="https://sitati.vercel.app" target="_blank">Designed and developed by Sitati</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
// No props needed for footer
</script>
